import { render, staticRenderFns } from "./homeWork.vue?vue&type=template&id=64245592&"
import script from "./homeWork.vue?vue&type=script&lang=ts&"
export * from "./homeWork.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports